import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = { class: "accessories-grid" }
const _hoisted_4 = { class: "accessory-card" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "accessory-card" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "accessory-card" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "accessory-card" }
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppLayout = _resolveComponent("AppLayout")!

  return (_openBlock(), _createBlock(_component_AppLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Lorem", -1)
            ]))]),
            _: 1
          }),
          _cache[2] || (_cache[2] = _createElementVNode("span", null, " → ", -1)),
          _createVNode(_component_router_link, { to: "/products" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Ipsum", -1)
            ]))]),
            _: 1
          }),
          _cache[3] || (_cache[3] = _createElementVNode("span", null, " → ", -1)),
          _cache[4] || (_cache[4] = _createElementVNode("span", null, "Lorem ipsum", -1))
        ]),
        _cache[17] || (_cache[17] = _createElementVNode("h1", { class: "page-title" }, "Lorem ipsum dolor", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: $data.placeholderImg,
              alt: ""
            }, null, 8, _hoisted_5),
            _cache[5] || (_cache[5] = _createElementVNode("h3", null, "Lorem ipsum VISYON", -1)),
            _cache[6] || (_cache[6] = _createElementVNode("p", null, "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt.", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("a", {
              href: "#",
              class: "card-link"
            }, "Lorem Ipsum", -1))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              src: $data.placeholderImg,
              alt: ""
            }, null, 8, _hoisted_7),
            _cache[8] || (_cache[8] = _createElementVNode("h3", null, "Lorem ipsum 7S", -1)),
            _cache[9] || (_cache[9] = _createElementVNode("p", null, "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor.", -1)),
            _cache[10] || (_cache[10] = _createElementVNode("a", {
              href: "#",
              class: "card-link"
            }, "Lorem Ipsum", -1))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("img", {
              src: $data.placeholderImg,
              alt: ""
            }, null, 8, _hoisted_9),
            _cache[11] || (_cache[11] = _createElementVNode("h3", null, "Lorem PC-12", -1)),
            _cache[12] || (_cache[12] = _createElementVNode("p", null, "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod.", -1)),
            _cache[13] || (_cache[13] = _createElementVNode("a", {
              href: "#",
              class: "card-link"
            }, "Lorem Ipsum", -1))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              src: $data.placeholderImg,
              alt: ""
            }, null, 8, _hoisted_11),
            _cache[14] || (_cache[14] = _createElementVNode("h3", null, "Lorem ipsum dolor", -1)),
            _cache[15] || (_cache[15] = _createElementVNode("p", null, "Lorem ipsum dolor sit amet, consectetur adipiscing elit.", -1)),
            _cache[16] || (_cache[16] = _createElementVNode("a", {
              href: "#",
              class: "card-link"
            }, "Lorem Ipsum", -1))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}